export const ChevronDownIcon = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13 5.5L7.78261 10.5L3 5.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
